import { ObserverService, ContentService } from "@DavisDigital/davisdigitalfrontend.module";
import { AccessAccount} from "@DavisDigital/interfaces";

export type ShareModalType = 'portfolio' | 'folder' | 'lesson';

class ArchiveModalController {
    
    private close:Function; //injected from modal-service
    
    public title: string;
    public baseObjectId: string;
    public archiveAction:boolean;
    public archiveText: string = "archive";
    public type: ShareModalType;
    
	
	// @ngInject
	constructor(
		public $timeout         : ng.ITimeoutService,
		public contentService   : ContentService, 
		public observerService  : ObserverService
	){}
	
	public $onInit = () => {
        if(this.archiveAction == false) {
        	this.archiveText = "unarchive";
        }
	}
	
	public onCloseModal = () =>{
		this.close();
	}
	
	public saveArchive = () => {
		this.contentService.saveArchive(this.baseObjectId, this.type, this.archiveAction).then(result => {
			
			if( result?.successfulActions?.length ) {
				this.onCloseModal();
			}
			//ToDo: handle errors
		})
	}
}
    

class ArchiveModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    title: "<",
	    baseObjectId: "<",
	    type: "<",
	    archiveAction: "<",
		close:'='
	};

	public controller = ArchiveModalController;
	public controllerAs = 'archiveModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/archive-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ArchiveModal };
